 "use client";

import { useState } from 'react';
import { useCalendarByResource } from '../useCalendar';
import { useAuthenticated } from '../authenticated/useAuthenticated';
import { useOrganizationSettings } from '../settings/useOrganizationSettings';
import { useRoomReservation } from './useRoomReservation';
import { useTacticHooks } from '../../providers/TacticHooksProvider';

const integrationsUrl = process.env.NEXT_PUBLIC_TACTIC_INTEGRATIONS_URL;

export const useRoomReservationWeb = ({
  isOpen,
  isRoomReservation: mayNeedDelegatedAccess,
}: {
  isOpen: boolean;
  isRoomReservation: boolean;
}) => {
  const { api } = useTacticHooks();
  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();
  const organization = authenticatedUser?.organization;

  const [roomId, setRoomId] = useState<string | null>(null);
  const { calendar } = useCalendarByResource(roomId || null);
  const { data: organizationSettings } = useOrganizationSettings({
    id: organization?.id,
    disabled: !mayNeedDelegatedAccess || !isOpen,
    refetchInterval: 60 * 1000 // 1 min
  });

  return {
    onRoomChange: (roomId: string | null) => {
      setRoomId(roomId);
    },
    ...useRoomReservation({
    isOpen,
    isRoomReservation: mayNeedDelegatedAccess,
    calendar: calendar || null,
    organizationSettings: organizationSettings || null,
    slug: organization?.slug || '',
    integrationsUrl: integrationsUrl || '',
    apiClient: api.client.calendarAuth
  })
  }
};
